import { faPencil } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Divider } from '@mui/material'
import { Button, CircularProgress, Popover, Stack, Typography } from '@vapor/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

type ReservedResourcesUpdateActionProps = {
  onEditReservedResourcesClick: () => void
  onDeleteReservedResourcesClick: () => void
  onEditReservedResourcesChargeCategoryClick: () => void
  disabled?: boolean
  showLoadingDeletion: boolean
  close?: boolean
}

export default function ReservedResourcesUpdateAction(props: ReservedResourcesUpdateActionProps) {
  const { onEditReservedResourcesClick, onDeleteReservedResourcesClick, onEditReservedResourcesChargeCategoryClick, disabled, showLoadingDeletion } = props
  const { t } = useTranslation()

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    if (props.close) setAnchorEl(null)
  }, [props.close])

  const open = Boolean(anchorEl)

  return (
    <div>
      <Button variant="outlined" size="small" onClick={handleClick} disabled={disabled}>
        <FontAwesomeIcon icon={faPencil} style={{ marginRight: 2 }} />
        <span style={{ marginLeft: 2, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t('pms.booking.reservation.action.edit_resources')}</span>
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: { style: { minWidth: `140px` } },
        }}
      >
        <Stack direction="column" justifyContent="center" alignItems="stretch" spacing={0}>
          <Button
            color="secondary"
            onClick={onEditReservedResourcesClick}
            fullWidth
            sx={{
              whiteSpace: 'nowrap',
              justifyContent: 'flex-start',
              backgroundColor: 'transparent',
            }}
            disabled={disabled}
          >
            <Typography variant="body">{t('pms.booking.reservation.action.edit_resources.edit')}</Typography>
          </Button>
          <Divider />
          <Button
            color="secondary"
            onClick={onDeleteReservedResourcesClick}
            fullWidth
            sx={{
              whiteSpace: 'nowrap',
              justifyContent: 'flex-start',
              backgroundColor: 'transparent',
            }}
            disabled={disabled}
          >
            <Stack direction="row" spacing={1} alignItems="center" width="100%">
              {showLoadingDeletion && <CircularProgress size="20px" />}
              <Typography variant="body">{t('pms.booking.reservation.action.edit_resources.delete_charge_categories')}</Typography>
            </Stack>
          </Button>
          <Divider />
          <Button
            color="secondary"
            onClick={onEditReservedResourcesChargeCategoryClick}
            fullWidth
            sx={{
              whiteSpace: 'nowrap',
              justifyContent: 'flex-start',
              backgroundColor: 'transparent',
            }}
            disabled={disabled}
          >
            <Typography variant="body">{t('pms.booking.reservation.action.edit_resources.edit_charge_categories')}</Typography>
          </Button>
        </Stack>
      </Popover>
    </div>
  )
}
